module.exports = __webpack_public_path__ + "static/media/4 Way intersection.50207abc.png";